<template>
  <tr class="row">
    <th>
      <p class="text-gray-900">
        {{ legalAd.reference }}
      </p>
      <p
        v-if="legalAd.altName"
        class="mt-1 font-normal text-gray-500"
      >
        {{ legalAd.altName }}
      </p>
    </th>
    <td class="text-center">
      {{ orderedAt }}
    </td>
    <td class="text-center">
      {{ publishingAt }}
    </td>
    <td class="text-center">
      {{ totalAmount }}
      <span
        v-if="isCurrentAccountPro && paid"
        class="px-2 py-1 text-xs bg-green-100 text-success rounded-xl"
      >payée</span>
    </td>
    <td class="text-center">
      <font-awesome-icon
        v-if="clientBilling"
        icon="check"
        class="text-success"
      />
      <div v-else>
        -
      </div>
    </td>
    <td class="text-center">
      <div
        v-if="isPending"
        class="inline-block ml-3 btn btn-success"
      >
        <font-awesome-icon
          icon="spinner"
          spin
          class="mr-2"
          size="lg"
        />
        Attestation en cours de création...
      </div>
      <a
        v-else
        :href="legalAd.certificatePDFUrl"
        class="ml-3 btn btn-success"
        target="_blank"
      >
        <font-awesome-icon
          icon="file-download"
          class="mr-2"
          size="lg"
        />
        Attestation
      </a>

      <a
        v-if="legalAd.proofPDFUrl"
        :href="legalAd.proofPDFUrl"
        class="ml-3 btn btn-success"
        target="_blank"
      >
        <font-awesome-icon
          icon="file-download"
          class="mr-2"
          size="lg"
        />
        Justificatif
      </a>
      <a
        v-if="legalAd.invoicePDFUrl"
        :href="legalAd.invoicePDFUrl"
        class="ml-3 btn btn-purple"
        target="_blank"
      >
        <font-awesome-icon
          icon="file-download"
          class="mr-2"
          size="lg"
        />
        Facture
      </a>
      <a
        v-if="legalAd.creditPDFUrl"
        :href="legalAd.creditPDFUrl"
        class="ml-3 btn btn-purple"
        target="_blank"
      >
        <font-awesome-icon
          icon="file-download"
          class="mr-2"
          size="lg"
        />
        Avoir
      </a>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'MyAccountLegalAd',
  props: {
    legalAd: {
      type: Object,
      default: null
    }
  },
  computed: {
    paid() {
      return this.legalAd.proPaid || (this.legalAd.paid && this.legalAd?.clientEmail?.length > 0);
    },
    totalAmount() {
      return this.numberToCurrency(this.legalAd.totalAmount);
    },
    orderedAt() {
      return this.legalAd.orderedAt ? this.formatDate(new Date(this.legalAd.orderedAt)) : null;
    },
    publishingAt() {
      return this.legalAd.publishingAt ? this.formatDate(new Date(this.legalAd.publishingAt)) : null;
    },
    isPending() {
      return this.legalAd.certificatePDFUrl === undefined;
    },
    clientBilling() {
      return this.legalAd?.clientEmail?.length > 0;
    }
  },
  watch: {
    isPending: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue && !oldValue) {
          this.refreshingInterval = setInterval(() => {
            this.$emit('refresh');
          }, 10000);
        } else {
          this.stopRefreshing();
        }
      }
    }
  },
  destroyed() {
    this.stopRefreshing();
  },
  methods: {
    stopRefreshing() {
      if (this.refreshingInterval) {
        clearInterval(this.refreshingInterval);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  .row {
    td, th {
      @apply border-b border-gray-200 py-3 px-3;
    }
  }

  .btn {
    @apply px-4 py-2 text-xs rounded rounded-xl transition-all;
    &.btn-success {
      @apply bg-success text-white hover:bg-opacity-90;
    }

    &.btn-purple {
      @apply bg-primary text-white hover:bg-opacity-90;
    }
  }
</style>
